<template>
  <el-container>
    <el-aside
      style="height:100% position:fixed; z-index:1001; overflow-x:hidden"
      :style="{width:asideWidth}"
    >
      <SidebarMenu
        :menu="sidebarMenu"
        @child-onCollapse="onSidebarCollapse"
        @child-selected="handleSidebarMenuAction">
      </SidebarMenu>
    </el-aside>
    
    <el-container direction="vertical" :style="{width:containerWidth}">
      <el-header class="custom-header">
        <Header />
      </el-header>
      
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import SidebarMenu from '@/components/backstage/SidebarMenu/SidebarMenu.vue'
import Header from '@/components/backstage/Header/Header.vue'
import PageName  from '@/views/backstage/constants/PageName'

  export default {
    components: {
      SidebarMenu,
      Header
    },
    data() {
      return {
        asideWidth: '200px',
        containerWidth: 'calc(100% - 200px)',
        sidebarMenu: {
          backgroundColor: '#196f3d',
          textColor: '#FFF',
          activeTextColor: '#FFF',
          isCollapse: false,
          defaultActive: '', // 對應'link'的index
          defaultOpeneds: [ // 對應'submenu'的index
            ''
          ],
          title: {
            fullTitle: '蘭陽地區林業文化歷史資料庫',
            subTitle: '',
            shortTitle: '林業'
          },
        }
      }
    },
    created () {
      this.do_data_preload()
    },
    mounted () {
      let menu_list = [
        {
          type: 'link',
          index: '/dashboard',
          icon: 'el-icon-menu',
          label: PageName.PAGE_DASHBOARD,
          action: this.handleRoute
        },
        {
          type: 'link',
          index: '/integrated-search',
          icon: 'el-icon-search',
          label: PageName.PAGE_INTEGREATED_SERACH,
          action: this.handleRoute
        },
        {
          type: 'link',
          index: '/digital-resource-management',
          icon: 'el-icon-document',
          label: PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT,
          action: this.handleRoute
        },
        {
          type: 'submenu',
          index: '/review-management',
          icon: 'el-icon-view',
          label: PageName.PAGE_GROUP_REVIEW_MANAGEMENT,
          list: [
            {
              type: 'link',
              index: '/review-management',
              icon: '',
              label: PageName.PAGE_REVIEW,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/review-management/front-stage-data-publish',
              icon: '',
              label: PageName.PAGE_FRONT_STAGE_DATA,
              action: this.handleRoute
            },
          ]
        },
        {
          type: 'submenu',
          index: '/file-type-management',
          icon: 'el-icon-document',
          label: PageName.PAGE_GROUP_FILE_TYPE_MANAGEMENT,
          list: [
            {
              type: 'link',
              index: '/file-type-management/recordgroup',
              icon: '',
              label: PageName.PAGE_RECORDGROUP_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/file-type-management/sub_recordgroup',
              icon: '',
              label: PageName.PAGE_SUB_RECORDGROUP_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/file-type-management/folder',
              icon: '',
              label: PageName.PAGE_FOLDER_MANAGEMENT,
              action: this.handleRoute
            },
          ]
        },
        {
          type: 'submenu',
          index: '/system-management/account-management',
          icon: 'el-icon-setting',
          label: PageName.PAGE_GROUP_SYSTEM_MANAGEMENT,
          list: [
            {
              type: 'link',
              index: '/system-management/account-management',
              icon: '',
              label: PageName.PAGE_ACCOUNT_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/system-management/system-log',
              icon: '',
              label: PageName.PAGE_SYSTEM_LOG,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/system-management/issue-report',
              icon: '',
              label: PageName.PAGE_ISSUE_REPORT_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/system-management/synonym-management',
              icon: '',
              label: PageName.PAGE_SYNONYM_MANAGEMENT,
              action: this.handleRoute
            },
          ]
        },
        {
          type: 'link',
          index: '/my-issue-report',
          icon: 'el-icon-question',
          label: PageName.PAGE_MY_ISSUE_REPORT,
          action: this.handleRoute
        },
        {
          type: 'submenu',
          index: '/front-stage-management',
          icon: 'el-icon-news',
          label: PageName.PAGE_GROUP_FRONT_STAGE_MANAGEMENT,
          list: [
            {
              type: 'link',
              index: '/front-stage-management/theme-management',
              icon: '',
              label: PageName.PAGE_THEME_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/front-stage-management/latest-news-management',
              icon: '',
              label: PageName.PAGE_LATEST_NEWS_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/front-stage-management/recommended-article-management',
              icon: '',
              label: PageName.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT,
              action: this.handleRoute
            },
            {
              type: 'link',
              index: '/front-stage-management/frequently-asked-question-management',
              icon: '',
              label: PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT,
              action: this.handleRoute
            }
          ]
        },
      ]
      
      let mark_enable = (menu) => {
        if (Array.isArray(menu)) {
          for (let m of menu) {
            let enable = this.permission_check({
              resource_info: { name: m['label'] },
              access: { name: this.permission.VIEW },
            })
            m['enable'] = enable

            if (m['type'] === 'submenu') {
              mark_enable(m['list'])
            }
          }
        }
        else {
          let enable = this.permission_check({
              resource_info: { name: menu['label'] },
              access: { name: this.permission.VIEW },
            })
            menu['enable'] = enable

            if (menu['type'] === 'submenu') {
              mark_enable(menu['list'])
            }
        }
      }

      mark_enable(menu_list)

      console.log('Index: menu_list:', menu_list)
   
      this.$set(this.sidebarMenu, 'list', menu_list)
    },
    methods: {
      onSidebarCollapse (isCollapse) {
        if (isCollapse) {
          var self = this
          setTimeout(() => {
            self.asideWidth = '64px'
            self.containerWidth = 'calc(100% - 64px)'
          }, 300)
        } else {
          this.asideWidth = '200px'
          this.containerWidth = 'calc(100% - 200px)'
        }
      },
      handleSidebarMenuAction (item) {
        if (item.type === 'link') {
          this.backstage_router_push({ path: item.index })
        } else if (item.type === 'logout') {
          this.logout(item)
        } else if (item.type === 'info') {
          // do nothing
        }
      },
      async do_data_preload () {
        console.log('doing data preload')
        await this.fetch_available_roles()
        console.log('data preload done')
      }
    }
  };
</script>

<style lang="scss" scoped>
  .custom-header {
    position: relative;
    line-height: 60px;
    color: #333;
    box-shadow: 0 4px 13px rgba(0, 0, 0, 0.12);
    z-index: 10;
  }
  /deep/ .el-submenu .el-icon-menu,
  /deep/ .el-submenu__title i {
    color: #fff;
  }
</style>
